import { render, staticRenderFns } from "./Chat.vue?vue&type=template&id=7a71dec7&scoped=true&"
import script from "./Chat.vue?vue&type=script&lang=js&"
export * from "./Chat.vue?vue&type=script&lang=js&"
import style0 from "@/assets/sass/layouts/default.scss?vue&type=style&index=0&id=7a71dec7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a71dec7",
  null
  
)

export default component.exports